import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useWarehouseModel } from "../warehouseModel";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const DataBox = () => {
    const { selectedRowKeys, updateEditFormVal, setAddWaerVisible } = useWarehouseModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const onEdit = () => {
        if (!selectedRowKeys) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let supplierEditKey = "13-3-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRowKeys, mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "仓库跳转详情",
                title:Locale["Jump to the detail page"],
                type: "warning",
                // text: "您还有仓库详情未保存，是否跳转",
                text:Locale["The detail page has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRowKeys, mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setAddWaerVisible(true)}
        >{Locale["Add"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >{Locale["Edit"]}</Button>
    </>;

    return (
        <YhBox title={action}>
            <DataTable />
        </YhBox>
    )
}